export const FETCH_USER_DETAILS = 'auth.fetchUserDetails';
